import axios from "axios";

const updateCompanySalesEmail = async (id, salesEmail) => {
  try {
    const response = await axios.put(
      `/account/system-admin/api/v1/company/${id}/sales-email`,
      {
        sales_email: salesEmail,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error updating company sales email:", error);
    throw error;
  }
};

export default updateCompanySalesEmail;
